import {map} from "lodash-es";
import {getHistoryUnitsJsonSuccess, getUnitsJsonSuccess} from "modules/actions/units";
import Api from "modules/utils/Api";
import {call, put} from "typed-redux-saga/macro";

export const fetchUnitsSaga = function* () {
	const units = yield* call(Api.Jsons.units);
	if (units?.data.units?.length) {
		yield* put(getUnitsJsonSuccess(units.data.units));
	}
};

export const fetchHistoryUnitsSaga = function* () {
	const units = yield* call(Api.Jsons.history_units);
	yield* put(
		getHistoryUnitsJsonSuccess(
			map(units.data.units, (it) => ({
				...it,
				lineups: [],
			}))
		)
	);
};

export default fetchUnitsSaga;
